module.exports = __webpack_public_path__ + "img/bgabout.41086175.png";